export default __webpack_public_path__ + "static/media/Plus Circle.9afda375.svg";